import angular from 'angular';

import { licensesView } from './licenses.view';

export default angular.module('portainer.app.license-management.licenses-view', []).component('licensesView', licensesView).name;
